export default __webpack_public_path__ + "static/media/SQS-ISO-9001.626c2a97.jpg";